import { render } from "./MainMenu.vue?vue&type=template&id=9df8925c&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=9df8925c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df8925c"]])

export default __exports__